/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { createEntity } from 'jotai/entity';
import { SystemWorkspaceId, WorkspaceObject } from 'jotai/workspace';
import { systemWorkspaceIdSlug } from 'jotai/workspace/SystemWorkspaceId';
import { OriginType, SanctioningBodyEnum } from 'models/viewModels';

export const defaultRaceIndy: WorkspaceObject = {
  id: SystemWorkspaceId.DefaultRaceIndy,
  name: 'Default Race Indy',
  slug: systemWorkspaceIdSlug.defaultRaceIndy,
  owner: 'system',
  sanctioningBody: SanctioningBodyEnum.INDYCAR,
  activeView: 't0',
  views: {
    byId: {
      t0: { id: 't0', name: 'Combined Views', visualizations: ['v1', 'v2', 'v3', 'v4'], layouts: 'vl0' },
      t1: { id: 't1', name: 'Wind Weather', visualizations: ['v5', 'v6'], layouts: 'vl1' },
    },
    allIds: ['t0', 't1'],
  },
  viewLayouts: {
    byId: {
      vl0: [
        { i: 'v1', w: 2, h: 29, x: 0, y: 0 },
        { i: 'v2', w: 10, h: 13, x: 2, y: 0 },
        { i: 'v3', w: 10, h: 16, x: 2, y: 13 },
        { i: 'v4', w: 12, h: 9, x: 0, y: 29 },
      ],
      vl1: [
        { i: 'v5', w: 12, h: 17, x: 0, y: 29 },
        { i: 'v6', w: 12, h: 15, x: 0, y: 13 },
      ],
    },
    allIds: ['vl0', 'vl1'],
  },
  visualizations: {
    byId: {
      v1: { id: 'v1', name: 'Race Order Table', type: 'raceOrderTable', settings: 'vs1' },
      v2: { id: 'v2', name: 'Lap Times Table', type: 'lapTimesTable', settings: 'vs2' },
      v3: { id: 'v3', name: 'Lap Times Graph', type: 'lapTimesGraph', settings: 'vs3' },
      v4: { id: 'v4', name: 'Running Order Table', type: 'runningOrderTable', settings: 'vs4' },
      v5: { id: 'v5', name: 'Indy Wind Weather Graph', type: 'indyWindWeatherGraph', settings: 'vs5' },
      v6: { id: 'v6', name: 'Indy Wind Weather Station Map', type: 'indyWindWeatherMap', settings: 'vs6' },
    },
    allIds: ['v1', 'v2', 'v3', 'v4', 'v5', 'v6'],
  },
  visualizationSettings: {
    byId: {
      vs1: {
        id: 'vs1',
        columnStates: [
          { colId: 'runningposition', sort: 'asc', width: 50 },
          { colId: 'vehiclenumber', width: 50 },
          { colId: 'driverfullname', hide: true, flex: 1 },
          { colId: 'lapscompleted', width: 50 },
          { colId: 'deltatotarget', flex: 1 },
          { colId: 'lapsled', width: 50 },
          { colId: 'lastlaptime', flex: 1 },
          { colId: 'bestlaptime', flex: 1 },
          { colId: 'movingaveragelaptime', hide: true, flex: 1 },
          { colId: 'runName', hide: true, flex: 1 },
        ],
        localVehicleSelections: {
          useLocalSelections: false,
          selectedGroup: 'none',
          selectedOems: [],
          selectedPerformances: [],
          selectedLeader: 'leaderOnly',
          individualSelections: [],
        },
        dataFeedSelections: OriginType.MULTILOOP,
      },
      vs2: {
        id: 'vs2',
        localVehicleSelections: {
          useLocalSelections: false,
          selectedGroup: 'none',
          selectedOems: [],
          selectedPerformances: [],
          selectedLeader: 'leaderOnly',
          individualSelections: [],
        },
        dataFeedSelections: OriginType.MULTILOOP,
      },
      vs3: {
        id: 'vs3',
        lapsFrom: 1,
        lapsAutoIncrement: false,
        localVehicleSelections: {
          useLocalSelections: false,
          selectedGroup: 'none',
          selectedOems: [],
          selectedPerformances: [],
          selectedLeader: 'leaderOnly',
          individualSelections: [],
        },
        dataFeedSelections: OriginType.MULTILOOP,
      },
      vs4: {
        id: 'vs4',
        localVehicleSelections: {
          useLocalSelections: false,
          selectedGroup: 'none',
          selectedOems: [],
          selectedPerformances: [],
          selectedLeader: 'leaderOnly',
          individualSelections: [],
        },
        dataFeedSelections: OriginType.MULTILOOP,
      },
      vs5: {
        id: 'vs5',
      },
      vs6: {
        id: 'vs6',
      },
    },
    allIds: ['vs1', 'vs2', 'vs3', 'vs4', 'vs5', 'vs6'],
  },
  selectedCompetitorGroups: {},
  competitorGroups: createEntity(),
  competitorGroupVehicles: createEntity(),
  selectedReferenceVehicle: createEntity(),
  hideFooter: false,
  trackMapSettings: createEntity(),
};
